type E2EUserHeaderGetter = () => string | null

let getter: E2EUserHeaderGetter = () => null

export function setE2EUserHeaderGetter(g: E2EUserHeaderGetter): void {
  getter = g
}

export function getE2EUserHeader(): string | null {
  return getter()
}
